import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment'

@Injectable({
  providedIn: 'root'
})
export class UpdateSubjectsServices {
    constructor(private http: HttpClient, private router: Router) { }


/*(Requirement title*,Image , details *)
*/
createSubject($data: any) {
    return this.http.post(checkUrl()+"/subject/add",$data)
    .pipe((response)=>{
        return response;
    })
}

// (Requirement title ,Image , details)
updateSubject($data:any){
    return this.http.post(checkUrl()+"/subject/edit",$data)
    .pipe((response)=>{
          return response;
    })
}

// Requirment ( Id *)
deleteSubject($data:any){
    return this.http.post(checkUrl()+"/subject/delete",$data)
    .pipe((response)=>{
          return response;
    })
}

}
